export enum TriggerType {
    SYSTEM = 'System',
    USER = 'User'
}
